

export const PlaceId = (props:{placeId: string}) => {
  return (
    <>
      <span style={{ textDecoration: "none", fontSize: "16px", color: "#3C4043", marginLeft:"1em", cursor:'pointer', fontWeight: 500 }}>
        Place ID              
      </span>
      <div className="title-box">
        <div style={{ margin: "1em 0 0 0", display: "flex", justifyContent: "flex-start" }}>
            <span style={{ color: "slategrey" }}>              
                {props.placeId}
            </span>
        </div>                
      </div>
    </>
  )
}
